import { buildRequests } from "../lib/requests";
import type { PlayRequestsData } from "../lib/types";
import type { PlayApi } from "./play-api";
import type { PlayShellInternal } from "./play-shell";
export async function readPlayRequests({
  api,
  shell,
}: {
  readonly api: PlayApi;
  readonly shell: PlayShellInternal;
}): Promise<PlayRequestsData> {
  const common = {
    league: shell.league,
    generatedAt: new Date().toISOString(),
  };

  if (!shell.signedIn)
    return {
      ...common,
      credits: null,
      requests: buildRequests({
        requests: null,
        windowStartedAt: null,
        windowEndedAt: null,
      }),
    };

  const [credits, rounds] = await Promise.all([
    api.credits(),
    shell.divisionId
      ? api.rounds({
          divisionId: shell.divisionId,
          status: "completed",
          limit: 50,
        })
      : null,
  ]);

  if (!credits || (shell.divisionId && !rounds))
    throw new Error("Experience requests are unavailable");

  return {
    ...common,
    credits: {
      balance: credits.status.balance_credits,
      spentThisPeriod: credits.status.spent_this_period_credits,
    },
    requests: buildRequests({
      requests: credits.recent_requests,
      windowStartedAt: rounds?.entries.at(-1)?.completed_at ?? null,
      windowEndedAt: rounds?.entries[0]?.completed_at ?? null,
    }),
  };
}
